import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    project: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const API_BASE = window.location.hostname === 'localhost' ? 
        'http://localhost:3000/contact-api' : '/contact-api';
      
      const response = await fetch(`${API_BASE}/send-email.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      
      if (result.success) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          project: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
        console.error('Form submission error:', result.error);
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <section className="contact-section" id="contact">
      <div className="zigzag"></div>
      
      <div className="contact-content">
        <div className="section-header">
          <h2>GET IN TOUCH</h2>
          <div className="header-ornament">◆ ◆ ◆</div>
          <p>Let's create something beautiful together</p>
        </div>
        
        <div className="contact-grid">
          <div className="contact-form art-deco-border">
            <form onSubmit={handleSubmit}>
              {submitStatus === 'success' && (
                <div className="form-success art-deco-border">
                  <div className="success-ornament">◆</div>
                  <p>Thank you for your message. We will get back to you soon!</p>
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="form-error art-deco-border">
                  <div className="error-ornament">▲</div>
                  <p>Failed to send message. Please try again later.</p>
                </div>
              )}
              
              <div className="form-group">
                <label htmlFor="name">NAME</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  required 
                  value={formData.name}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">EMAIL</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  required 
                  value={formData.email}
                  onChange={handleChange}
                  disabled={isSubmitting}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="project">PROJECT TYPE</label>
                <select 
                  id="project" 
                  name="project"
                  value={formData.project}
                  onChange={handleChange}
                  disabled={isSubmitting}
                >
                  <option value="">Select a project type</option>
                  <option value="pattern-design">Pattern Design</option>
                  <option value="interior-design">Interior Design</option>
                  <option value="product">Product Design</option>
                  <option value="branding">Branding</option>
                  <option value="custom">Custom Pattern</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">MESSAGE</label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="4" 
                  required 
                  value={formData.message}
                  onChange={handleChange}
                  disabled={isSubmitting}
                ></textarea>
              </div>
              
              <button type="submit" className="submit-btn" disabled={isSubmitting}>
                <span>{isSubmitting ? 'SENDING...' : 'SEND MESSAGE'}</span>
                <span className="btn-ornament">◆</span>
              </button>
            </form>
          </div>
          
          <div className="contact-info">
            <div className="info-card art-deco-border">
              <h3>STUDIO</h3>
              <p>Remote</p>
              <div className="info-ornament">●</div>
            </div>
            
            <div className="info-card art-deco-border">
              <h3>EMAIL</h3>
              <p>medecadeinterior@gmail.com</p>
              <div className="info-ornament">▲</div>
            </div>
            
            <div className="info-card art-deco-border">
              <h3>PHONE</h3>
              <p>509-824-2862</p>
              <div className="info-ornament">◆</div>
            </div>
            
            <div className="social-links">
              <h4>FOLLOW US</h4>
              <div className="social-ornaments">
                <span className="social-ornament">■</span>
                <span className="social-ornament">●</span>
                <span className="social-ornament">▲</span>
                <span className="social-ornament">■</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="zigzag"></div>
    </section>
  );
};

export default Contact;